import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoVeteranFlag = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>VeteranFlag</title>
    <path
      d="M4.81 21.377v7.46M4.81 7.443s3.378-.854 5.595-.97c4.434-.233 6.757 1.996 11.191 1.763 2.217-.116 5.595-.793 5.595-.793v14.812s-3.378.853-5.595.97c-4.434.233-6.757-1.996-11.191-1.764-2.217.117-5.595.794-5.595.794V7.443Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.191 17.283s-3.378.789-5.595.909c-4.434.24-6.757-2.057-11.191-1.817-2.217.12-5.596.908-5.596.908M27.192 12.362s-3.379.788-5.596.908c-1.773.096-3.21-.214-4.577-.605"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoVeteranFlag;
